import Trans from 'next-translate/Trans'
import React, { useState } from 'react'
import useMap from 'tennders-transactions/hooks/useMap'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import TrackButton from './TrackButton'

const WithCondition = ({ condition, submitting, action, children, className }) => (
  condition ? (
    <GHref
      submitting={submitting}
      onClick={action}
      className={className || 'btn-border standard-btn small mr-10 tennders-accept-offer-btn'}
    >
      {children}
    </GHref>
  ) : null
)
const ActionButtons = ({ offer, onAccepted }) => {
  const [submitting, setsubmitting] = useState(false)
  const [accepting, setaccepting] = useState(false)
  const [rejecting, setrejecting] = useState(false)
  const [tracked, settracked] = useState(false)
  const {
    acceptOffer,
    rejectOffer,
    setCounterMode,
    trackOffer
  } = useOffer()
  const { transaction } = useTransaction()

  const { setEditMode } = useMap()
  const triggerAccept = async () => {
    if (accepting) {
      setsubmitting(true)
      await acceptOffer(offer?.id)
      setsubmitting(false)
      if (onAccepted) {
        onAccepted()
      }
    } else {
      setaccepting(true)
    }
  }

  const triggerReject = async () => {
    if (rejecting) {
      setsubmitting(true)
      await rejectOffer(offer?.id)
      setsubmitting(false)
    } else {
      setrejecting(true)
    }
  }

  const triggerCounter = async (offer) => {
    setEditMode(true)
    setCounterMode(offer?.id)
  }

  const triggerTrack = async () => {
    await trackOffer(offer?.id)

    settracked(true)
  }

  const cancel = () => {
    setsubmitting(false)
    setaccepting(false)
    setrejecting(false)
  }

  if (offer?.timer) {
    return null
  }

  return (
    <div className="tennders-accept-counter-offer-btns text-right">
      {!offer?.isMyOffer ? (
        <>
          <WithCondition
            condition={!rejecting}
            action={triggerAccept}
            submitting={submitting}
          >
            {' '}
            <Trans i18nKey={accepting ? 'offer:confirmAndAcceptOffer' : 'offer:acceptOffer'} />
          </WithCondition>
          <WithCondition
            condition={!accepting && !rejecting}
            action={() => triggerCounter(offer)}
            submitting={submitting}
          >
            <Trans i18nKey="offer:counterOffer" />
          </WithCondition>
          <WithCondition
            condition={!accepting && !rejecting}
            label={<Trans i18nKey="offer:declineOffer" />}
            action={triggerReject}
            submitting={submitting}
            className="text-18  tennders-decline-offer-btn"
          >
            <FontAwesomeIcon icon={faCircleXmark} aria-hidden="true" />
          </WithCondition>
          <WithCondition
            condition={rejecting}
            action={triggerReject}
            submitting={submitting}
          >
            <Trans i18nKey="offer:confirmAndDeclineOffer" />
          </WithCondition>
          <WithCondition
            condition={accepting || rejecting}
            action={cancel}
          >
            <Trans i18nKey="offer:cancel" />
          </WithCondition>
        </>
      ) : (
        <TrackButton
          transaction={transaction}
          onClick={triggerTrack}
          tracked={tracked}
        />
      )}
    </div>
  )
}

export default ActionButtons
